import { VFC, useState, useEffect, useCallback, memo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Stack, Box, Link } from "@chakra-ui/react";
import { MyText } from '../atoms/text/MyText';
import { Menu } from "../../types/menu";
import { menuArray } from "../../router/Menu";
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";

type Props = {
  type?: string;
  onClose?: ()=>void;
};

export const Navigation: VFC<Props> = memo((props) => {
  const { onClose } = props;
  const location = useLocation();
  
  //const { type = "default" } = props;
  const { loginUser } = useLoginUser();
  const [ myMenu, setMyMenu ] = useState<Array<Array<Menu>>>([]);

  const navigate = useNavigate();
  const onClickLink = useCallback((link: string) => {
    navigate(link);
    onClose && onClose();
  }, [navigate,onClose]);
  
  // メニューの許可ポリシーに、ログインユーザのポリシーが含まれていたらtrue
  // const checkPolicy = (arr: Array<string>) => {
  //   const newArr = loginUser?.policies ?? ["ALLWAYS"];
  //   return [...newArr].filter((item: string) => arr.includes(item)).length > 0;
  //   //return true;
  // };
    
  // 必要なメニューのみにする
  useEffect(() => {
    let myMenuTmp = [];
    let group = loginUser.userGroup ? loginUser.userGroup : "all";
    group = group.replace(/G$/,"");

    myMenuTmp = menuArray.map((meueGroup: Array<Menu>) => {
      return( meueGroup.filter((item: Menu) => {
        if( item.groups[0] === 'all' ||
            item.groups.includes(group) ||
           (item.groups[0] === 'exceptExec' && group !== 'exec' ) ||
           (item.groups[0] === 'necdomain' && loginUser.necFlag ) ){
          return( item );
        }else{
          return( null );
        }}))
    });
    // envType === 'DEV' && console.log(myMenuTmp);
    
    myMenuTmp = myMenuTmp.filter((meueGroup: Array<Menu>) => {
      if( meueGroup.length !== 0 ){
        return( meueGroup );
      }else{
        return( null );
      }
    });
    
    // envType === 'DEV' && myMenuTmp && console.log(myMenuTmp);
    setMyMenu(myMenuTmp);
    
  }, [loginUser.userGroup]);
  
  return (
    <Stack as="nav" marginTop="10px" marginLeft="10px">
    {myMenu.map((groups: Menu[], index: number) => {
      return (
        <Box
          key={index}
          bg="white"
          padding="0px"
          borderRadius="10px"
          marginTop="0px"
        >
          {groups.map((obj: Menu) =>
            obj.link === "MAIN" ? (
             <Box
                bg={obj.color}
                w="100%"
                paddingLeft={2}
                color="white"
                key={obj.name}
                marginTop='12px'
                marginBottom='7px'
                borderRadius="10px"
              >
                <MyText str={obj.name} color='white' />
              </Box>
            ) : obj.link === "SUB" ? (
              <Box
                bg={obj.color}
                w="100%"
                paddingLeft={4}
                color="white"
                key={obj.name}
                marginBottom='7px'
                borderRadius="10px"
              >
                <MyText str={obj.name} color='white' />
              </Box>
            ) : (
              <Box key={obj.link} paddingLeft={4} marginBottom='7px' borderRadius="10px">
                {obj.link === location.pathname ? (
                  <MyText str={obj.name} color='blue' asStr="b" />
                ) : obj.link.match(/^http/) ? (
                  <Link href={obj.link} isExternal>
                    <MyText str={obj.name} color='black' />
                  </Link>
                ) : (
                  <Link onClick={() => onClickLink(obj.link)}>
                    <MyText str={obj.name} color='black' />
                  </Link>
                )}
              </Box>
            )
          )}
        </Box>
      );
    })}
    </Stack>
  );
});